export default import.meta.ROLLUP_FILE_URL_KaF_367DwSWuFvlFfN4rvw